export default "__VITE_ASSET__BGa651b$__"